// removed by extract-text-webpack-plugin
module.exports = {"container":"Calendar__container__3hPfC","separator":"Calendar__separator__p4baT"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/Calendar/Calendar.css
// module id = 466
// module chunks = 0